// @flow

import { type OutgoingPayment } from '../outgoing-payment/types';
import { type IncomingPayment } from '@tectonics/prs/incoming-payment';
import { type UserInputValues } from '@tectonics/prs/user-input-values';

export async function cashMexicoOutgoingPaymentMapper(userInputValues: UserInputValues, incomingPayment: IncomingPayment): Promise<$Shape<OutgoingPayment>> {

  return {
    payment_type: 'cash',
    payment_type_code: 'oxxopay',
    instalments: '1',
  };
}
